import { Link } from 'react-router-dom';

export type AlertTone = 'red' | 'amber' | 'blue';

export interface AttentionAlert {
  key: string;
  tone: AlertTone;
  title: string;
  detail: string;
  href: string;
}

const TONE_CLASSES: Record<AlertTone, string> = {
  red: 'bg-error-container text-on-error-container border-error-container',
  amber: 'bg-tertiary-fixed text-on-tertiary-fixed border-tertiary-fixed-dim',
  blue: 'bg-secondary-container text-on-secondary-container border-secondary-fixed-dim',
};

const DOT_CLASSES: Record<AlertTone, string> = {
  red: 'bg-error',
  amber: 'bg-tertiary-fixed-dim',
  blue: 'bg-primary',
};

interface Props {
  alerts: AttentionAlert[];
}

export function AttentionStrip({ alerts }: Props) {
  if (alerts.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-3 mb-5">
      {alerts.map((a) => (
        <Link
          key={a.key}
          to={a.href}
          className={`flex items-center gap-3 px-4 py-3 rounded-xl border text-sm font-medium flex-1 min-w-48 hover:opacity-90 transition-opacity ${TONE_CLASSES[a.tone]}`}
        >
          <span className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${DOT_CLASSES[a.tone]}`} />
          <span className="flex-1">
            <span className="font-semibold block">{a.title}</span>
            <span className="text-xs opacity-75">{a.detail}</span>
          </span>
          <span className="opacity-40 text-base">→</span>
        </Link>
      ))}
    </div>
  );
}
